<script setup>
  import { ref, onMounted, watchEffect, watch, onUnmounted } from 'vue';
  import { useProForecastModel } from '@/composables/useProForecastModel';
  import useLegacyBridge from "@/composables/useLegacyBridge";

  const content = defineModel('content');
  const selectedModelIds = defineModel('selectedModels');

  const props = defineProps({
    isNCWind: {
      type: Boolean,
      required: true
    },
    ncWindDataEnabled: {
      type: Boolean,
      required: false
    },
     useExternalDataBlock: {
      type: Boolean,
      default: false
    },
    zoom: {
      type: Number,
      required: false,
      default: 12
    },
    legendTarget: {
      type: HTMLElement,
      required: false
    },
    spotDataObject: {
      type: Object,
      required: true
    },
    useUniqueStoreKey: {
      type: Boolean,
      default: false
    },
    updateKey: {
      type: Number,
      default: () => Date.now()
    },
    isNowcast: {
      type: Boolean,
      default: false
    }
  });

  const uniqueStoreKey = props.useUniqueStoreKey ? Date.now() : null;

  const { basicGraph } = useLegacyBridge();
  const { showProForecastModel, getModelData: getProForecastModel } = useProForecastModel(
    () => props.spotDataObject,
    uniqueStoreKey
  );

  const uniqueGraphId = Date.now();

  const graphContainer = ref(null);
  const ncWindDataEnabled = ref(props.ncWindDataEnabled || false);
  const loaded = ref(false);

  const loadGraph = async () => {
    const settings = {
      graphId: uniqueGraphId,
      showObserved: !props.isNowcast,
      showModelData: true,
      // The Vue ModelSelector owns selection now; the graph reacts to it via
      // the EventBus instead of drawing its own selector.
      useExternalModelSelector: true,
      modelData: {...props.spotDataObject.forecastModelData},
      legendTarget: props.legendTarget,
      spotId: props.spotDataObject.spotId,
      favSpotId: props.spotDataObject.spotFavoriteId,
      lat: props.spotDataObject.lat,
      lon: props.spotDataObject.lon,
      type: 'detail',
      zoom: props.zoom,
      isNCWind: props.isNCWind,
			ncWindDataEnabled: ncWindDataEnabled.value
    }

    if (selectedModelIds.value) {
      settings.selectedModelIds = selectedModelIds.value
    }

    console.log("🚀 ~ WindGraphBasic.vue ~ loadGraph ~ showProForecastModel.value:", showProForecastModel.value)
    if (showProForecastModel.value) {
      const proForecastModelData = await getProForecastModel();

      if (proForecastModelData) settings.additionalModels = [proForecastModelData];
    }

    content.value = basicGraph(graphContainer.value, settings);
    loaded.value = true;
  }

  watchEffect(() => ncWindDataEnabled.value = props.ncWindDataEnabled || false);

  onMounted(() => {
    loadGraph();
  })

  onUnmounted(() => {
    content.value?.destroy?.();

    if (!props.legendTarget) return;

    const legend = props.legendTarget;
    legend.innerHTML = '';
  });

  watch(() => props.updateKey, () => {
    content.value.refresh();
  })  
</script>

<template>
  <div
    class="jwx-data-container__main-content"
    style="width: 100%; height: 100%; background-color: #ffffff;"
    ref="graphContainer"
  ></div>
 
</template>